import React from 'react'
import { Form, Input } from 'antd'
import { useTranslation } from 'lib/i18n'

const CompanyName: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Form.Item
      name={['VIDEO_REQUEST', 'businessName']}
      label={t('VideoRequestForm.companyLabel', 'Company name')}
      rules={[
        {
          required: true,
          message: t(
            'VideoRequestForm.companyRequired',
            'Fill in your company name',
          ),
        },
      ]}
      data-cy="companyNameInputItem"
    >
      <Input size="large" autoComplete="off" data-cy="companyNameInput" />
    </Form.Item>
  )
}

export default CompanyName
